export const USER_LIST_DEFAULT_ORDER_ID = 'LAST_ADDED';
